import React from 'react';
import PDFViewer from 'pdf-viewer-reactjs';

const link =
  'https://fh.filgolf.com/files/ele/C1_Audited_Financial_Statements_as_of_31_December_2015.pdf';

export default function C1() {
  return (
    <>
      <h5 className="is-size-5 mb-4">
        <strong>
          C.1. Audited Financial Statements as of 31 Decemeber 2015
        </strong>
      </h5>
      <a className="button  is-link" href={link} download>
        DOWNLOAD
      </a>
      <PDFViewer
        document={{
          url: link
        }}
        rotationAngle={-90}
        css="customViewer"
      />
    </>
  );
}
